import { apiClient, handleResp } from './utils';
export default {
  doBillingReset(dataInput) {
    return handleResp(apiClient().post('/billing_reset', dataInput));
  },
};
